<div class="d-flex flex-column justify-content-center align-items-center min-vh-100">
    <h2>Sale Not found</h2>
    <p>Please contact your representative to ensure you have the right link</p>
</div>
